module.exports = __webpack_public_path__ + "img/인덕원 미용실 1.062bc515.png";